export const UFPM_MODE_KEY = 'ufpmMode'
export const UFPM_TEST_SESSION_KEY = 'ufpm_test_session'

export function readUfpmModeEnabled(storage: Storage = localStorage): boolean {
  try {
    return storage.getItem(UFPM_MODE_KEY) === 'true'
  } catch {
    return false
  }
}

interface SessionMemberState {
  completion?: string
}

interface StoredTestSession {
  memberIds?: string[]
  members?: Record<string, SessionMemberState>
}

/** True when an active test session has unsaved work (draft or not-yet-saved members). */
export function hasUfpmTestSessionDrafts(storage: Storage = sessionStorage): boolean {
  try {
    const raw = storage.getItem(UFPM_TEST_SESSION_KEY)
    if (!raw) return false
    const parsed = JSON.parse(raw) as StoredTestSession
    const ids = parsed.memberIds ?? []
    if (!ids.length) return false
    const states = parsed.members ?? {}
    return ids.some(id => states[id]?.completion !== 'saved')
  } catch {
    return false
  }
}